import _ from 'lodash';
import React, { useMemo } from 'react';
import { Overlay } from './Overlay';
import { useGlobalContext } from '~/hooks';
import app from '~/app';
import { Form, yup, formError } from '~/forms';

export function LoginOverlay( props ) {
  const { dispatch } = useGlobalContext();

  const formcfg = useMemo( () => {
    return {
      className   : 'form-login',
      fields      : [
        {
          name      : 'username',
          type      : 'text',
          label     : 'Username',
          required  : true,
          validator : yup.string(),
        },
        {
          name      : 'password',
          type      : 'password',
          label     : 'Password',
          required  : true,
          validator : yup.string(),
        },
      ],
      onSubmit( data ) {
        return app.authenticate( { strategy  : 'local', ...data } )
          .then( () => dispatch.overlay.close() )
          .catch( err => formError( err.message ) );
      },
    };
  }, [ dispatch ] );

  return ( <Overlay title="Login"><Form {...formcfg} /></Overlay> );
}
LoginOverlay.propTypes = {};
